// Global Instructions Rule Applied!
//
// Tranches grid state (Operations > Tranches) — same shape as the
// assetTransactions slice: paginated rows + active filters/sorting.
// Tranches are read-only engine records, so no update/remove actions.
import {
  SET_TRANCHES,
  APPEND_TRANCHES,
  SET_TRANCHES_ACTIVE_FILTERS,
  SET_TRANCHES_ACTIVE_SORTING
} from './constants.ts'
import { FilterValue, SortConfig } from '../../../app_modules/global_configs/tableViewPreferences.ts'

export interface TranchesPaginatedResponse {
  data: Record<string, unknown>[]
  hasMore: boolean
  totalCount: number
  error?: string
}

export interface TranchesState {
  data: Record<string, unknown>[]
  activeFilters: FilterValue[]
  activeSorting: SortConfig[]
  hasMore: boolean
  currentPage: number
}

type TranchesAction =
  | { type: typeof SET_TRANCHES; payload: { response: TranchesPaginatedResponse } }
  | { type: typeof APPEND_TRANCHES; payload: { response: TranchesPaginatedResponse } }
  | { type: typeof SET_TRANCHES_ACTIVE_FILTERS; payload: { filters: FilterValue[] } }
  | { type: typeof SET_TRANCHES_ACTIVE_SORTING; payload: { sorting: SortConfig[] } }

const tranchesReducer = (
  state: TranchesState = {
    data: [],
    activeFilters: [],
    activeSorting: [],
    hasMore: false,
    currentPage: 1
  },
  action: TranchesAction
): TranchesState => {
  switch (action.type) {
    case SET_TRANCHES: {
      const { response } = action.payload
      return { ...state, data: response.data, hasMore: response.hasMore, currentPage: 1 }
    }
    case APPEND_TRANCHES: {
      const { response } = action.payload
      return {
        ...state,
        data: [...state.data, ...response.data],
        hasMore: response.hasMore,
        currentPage: state.currentPage + 1
      }
    }
    case SET_TRANCHES_ACTIVE_FILTERS: {
      return { ...state, activeFilters: action.payload.filters }
    }
    case SET_TRANCHES_ACTIVE_SORTING: {
      return { ...state, activeSorting: action.payload.sorting }
    }
    default:
      return state
  }
}

export default tranchesReducer

export const setTranches = (payload: { response: TranchesPaginatedResponse }) => ({
  type: SET_TRANCHES,
  payload
})

export const appendTranches = (payload: { response: TranchesPaginatedResponse }) => ({
  type: APPEND_TRANCHES,
  payload
})

export const setTranchesActiveFilters = (payload: { filters: FilterValue[] }) => ({
  type: SET_TRANCHES_ACTIVE_FILTERS,
  payload
})

export const setTranchesActiveSorting = (payload: { sorting: SortConfig[] }) => ({
  type: SET_TRANCHES_ACTIVE_SORTING,
  payload
})
